import "./MessageCouple.css";
import React, { useRef } from "react";
import ShareButton from "../ShareButton";
export default function MessageCouple({ highScore, messageText, coupleImage, coupleName, onClose }) {
    const messageScreen = useRef(null);
    const closeModal = () => {
        console.log('closeModal');
        onClose();
    }
  
    return (
        <div className="message-container">
            <div className="bg-overlay"></div>
            <div className="message-item">
                <div class="selk-contain" ref={messageScreen}>
                    <div class="selk-top">
                        <img src="../img/gradient_heart.jpg" alt="foto" />
                        <notif>!</notif>
                        <div>
                            Você lembrou deste momento
                            <tagged>{ coupleName }</tagged>
                        </div>
                    </div>
                    <div class="selk-svg"><svg viewBox="0 0 500 150" preserveAspectRatio="none"
                    ><path d="M0.00,49.98 C149.99,150.00 271.49,-49.98 543.73,84.38 L500.00,0.00 L0.00,0.00 Z"></path></svg></div>
                    <div class="selk-msg">
                        <received>
                            <message-text>
                                Oi meu amor
                            </message-text>
                        </received>

                        <received>
                            <message-text>
                                { messageText.description }
                            </message-text>
                        </received>
                        <received>
                            <message-picture>
                            <img
                            className="back"
                            src={coupleImage}
                            alt="card back"
                            width="200"  />
                            </message-picture>
                        </received>
                    </div>
                </div>

                <div className="message-notification">
                    <div className="button">
                        <ShareButton highScore={highScore}
                            highScoreRef={messageScreen}
                        />
                    </div>
                </div>
                
                <button className="button close-button" onClick={closeModal}>X</button>
            </div>
        </div>
    );
}
